module.exports = __webpack_public_path__ + "img/AI_Logo-ff4e72d9.773b8e20.png";